<template>
  <div class="container">
    <div class="mt-4 mb-2 d-flex justify-content-between">
      <back-arrow :title="$t('operationDocument.Share.Title.All')"/>
    </div>

    <div class="mt-4 border-grey">
      <b122-table
        ref="B122TablePartage"
        :delete-item="allowDelete"
        :edit-item="allowEdit"
        :create-item="false"
        empty-text=""
        :empty-title="$t('operationDocument.Share.emptyTitle').toString()"
        :fields="tableFields"
        :get-b122-table-results-url="'/partage/getB122TableResults?restrictbylong-operationId=' + operationId"
        :use-filters="false"
        :use-pagination="false"
        identifier="B122TablePartage"
        init-b122-table-url="/partage/initB122Table"
        @setTotalCount="setTotalCount">

        <template #cell(link)="data">
          <b-link class="main-color-text" v-if="data.item.link" :href="data.item.link">
             <u>{{data.item.link}}</u>
          </b-link>
        </template>
      </b122-table>
    </div>

  </div>
</template>

<script>

import BackArrow from "../../components/b122/BackArrow.vue";
import B122Table from "../../components/b122/B122Table.vue";

export default {
  name: "OperationShowAllLinks",

  components: {
    BackArrow,
    B122Table
  },

  data() {
    return {
      totalCount: 0,
      operationId: this.$route.params.operationId,
      allowCreate: false,
      allowEdit: false,
      allowDelete: false,
    }
  },

  computed: {
    tableFields() {
      return [
        {
          label: this.$t('operationDocument.Share.Name'),
          key: 'name',
          sortable: true
        },
        {
          label: this.$t('operationDocument.Share.Link'),
          key: 'link',
          sortable: false
        },
        {
          label: this.$t('operationDocument.Share.CreationDate'),
          key: 'creationDate',
          sortable: true
        },
        {
          label: this.$t('operationDocument.Share.ExpirationDate'),
          key: 'expirationDate',
          sortable: true
        },
        {
          label: this.$t('operationDocument.Share.Documents'),
          key: 'documents',
          sortable: true
        },
        {
          label: '',
          key: 'actions'
        }]
    }
  },

  methods: {
    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },
  }
}
</script>

<style scoped>

.border-grey {
  border: 1px solid var(--main-grey);
  padding: 15px;
  background-color: #FFFFFF;
}

</style>



// WEBPACK FOOTER //
// src/views/operationDocument/OperationShowAllLinks.vue